<template>
<!-- toastr -->
<transition name="fade">
    <div v-show="!isHide" class="toastr_in_wrap">
        <p><br class="mobile_only">{{ $t('MESSAGE.POPUP.RECOMMEND') }}</p>
        <div class="btn_wrap">
            <a href="javascript:" class="rdbtn_yes" @click="toastrRecommend">{{ $t('FIELD.GLOBAL.YES') }}</a>
            <a href="javascript:" class="rdbtn_no" @click="showBugReportPopup">{{ $t('FIELD.GLOBAL.NO') }}</a>
        </div>
    </div>
</transition>
<!-- //toastr -->
</template>

<script>
import Vue                                  from 'vue';
import qs                                   from 'query-string';
import axios                                from 'axios';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import BugReportPopup                       from '~c/popup/BugReportPopup';

export default {
    name: 'ContentsRecommendPopup',
    props: {
        inContents: { default: false },
    },
    data() {
        return {
            isHide: true,
            isKnowledge: true,
            knowledgeId: '',
            isScmsContents: false,
        }
    },
    computed: {
        getKnowledgeId() {
            return this.knowledgeId;
        }
    },
    watch: {
        $route(to, from) { 
            // 팝업이 오픈된 상태에서 이동이 감지되었을 때, 팝업은 무조건 닫는다.
            if (to.path != from.path) { 
                this.isHide = true;
            }
        }
    },
    methods: {
        toastrShow(showObj = { knowledgeId: '', scmsYn: false }) {
            if(!StringUtil.isNull(showObj.knowledgeId)) {
                this.knowledgeId = showObj.knowledgeId;
                this.isScmsContents = showObj.scmsYn;
                this.isHide = false;
                this.isKnowledge = true;

            } else {
                this.isHide = true;
                return false;
            }
        },
        toastrHide() {
            this.isHide = true;
        },
        toastrRecommend() {
            if(this.isKnowledge) {
                SDLUtil.showLoadingBar(true);
                let url = `${SDLUtil.API_URL}/basis/common/scrap/recommend.skp`,
                    fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: this.getKnowledgeId };
                // Vue.$log.info('▶ RecommendPopup.vue form Data => ', fvParams);
                return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                    .then(res => {
                        SDLUtil.showLoadingBar(false);
                        // Notification
                        Vue.toasted.show( SDLUtil.getMsgProp('MESSAGE.GLOBAL.RECOMMEND'), { theme: "toasted-primary", position: "top-center", duration : 3000 } );
                        this.isHide = true;
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.errorAlert(err);
                        this.isHide = true;
                    });

            } else {
                Vue.$log.warn('undefined recommend type.');
                this.isHide = true;
            }

        },
        showBugReportPopup() {
            this.toastrHide();

            SDLUtil.show(
                BugReportPopup,
                {
                    knowledgeId: this.getKnowledgeId,
                    isScmsContents: this.isScmsContents,
                    rtnFunc: () => {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.BUGREPORT.SEND.SUCCESS'),
                            {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                    }
                },
                { height: 'auto' }
            );
        }
    },
    activated() {
        // Vue.$log.info('▶ RecommendPopup.vue activated.');
        EventBus.$on('knowledge-detail-recommend-show', showObj => { this.toastrShow(showObj); });
        EventBus.$on('knowledge-detail-recommend-hide', ()      => { this.toastrHide(); });
    },
    mounted() {
        //
    },
    deactivated(){
        // Vue.$log.info('▶ RecommendPopup.vue deactivated.');
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('knowledge-detail-recommend-show');
        EventBus.$off('knowledge-detail-recommend-hide');
    }
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/ContentsRecommendPopup.vue